import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {OrganizzazioniService} from './organizzazioni.service';
import {OrdSped} from '../_models/OrdSped';
import {OrdSpedEsolver} from '../_models/OrdSpedEsolver';
import {BehaviorSubject, firstValueFrom, Subject} from 'rxjs';
import {OrdSpedGroup} from '../_models/OrdSpedGroup';
import {HubConnection} from '@microsoft/signalr';
import {buildHubConnection, startHubConnection, stopHubConnection} from '../_helpers/hub-connection.helper';
import {HubState} from '../_models/hub-state';
import {SaveMessage} from '../_helpers/save-message';
import {FilterItem} from '../_models/FilterItem';
import {SearchResult} from '../_models/SearchResult';
import {OrdSpedBox} from '../_models/OrdSpedBox';
import {OrdSpedRisorsa} from '../_models/OrdSpedRisorsa';
import {ReportResult} from '../_models/ReportResult';
import {AuthenticationService} from './authentication.service';
import {SpostaBancaleRequest, SpostaColloEsito, SpostaColloRequest} from '../_models/spedizioni/sposta-collo';

export interface UpdatePesoMedioUnitFromBilanciaRequest {
  organizzazioneId: number;
  idDocumento: number;
  idRiga: number;
  risorsaId: number;
  pesoMedioUnitFromBilancia: number;
}

const cachePrefix = 'archiconnect-v2-';
const emptyOrdSped: OrdSped = {
  organizzazioneId: 0,
  idDocumento: 0,
  idRiga: 0,
  periodoRifNumeraz: 0,
  numRegistraz: 0,
  dataRegistraz: new Date(),
  dataDoc: new Date(),
  numDocumento: '',
  codCliFor: 0,
  codCausaleTrasporto: '',
  desCausaleTrasporto: '',
  codPorto: '',
  desPorto: '',
  aspettoBeni: '',
  desAspettoBeni: '',
  codTrasportoAmezzo: '',
  desTrasportoAmezzo: '',
  spedNumRifIndir: 0,
  spedRagSoc1: '',
  spedRagSoc2: '',
  spedIndir1: '',
  spedIndir2: '',
  spedCap: '',
  spedLocalita1: '',
  spedLocalita2: '',
  spedProv: '',
  umPeso: '',
  totPesoLordo: 0,
  totPesoNetto: 0,
  umVolume: '',
  totVolume: 0,
  totaleColli: 0,
  spedIdAnagGen: 0,
  statoSpedizione: 0,
  codMagPrelievo: '',
  codAreaMagPrelievo: '',
  codMagTerzista: '',
  codAreaMagTerzista: '',
  codMagSped: '',
  spedCodCliFor: 0,
  codArt: '',
  varianteArt: '',
  desArt: '',
  rigaSaldata: false,
  codMag: '',
  codAreaMag: '',
  riferimentoRiga: '',
  lottoMagTipoGestione: 0,
  dataConsegnaConferm: new Date(),
  unitaMisura: '',
  qtaDaSpedire: 0,
  um2: '',
  qta2DaSpedire: 0,
  qtaPrelevata: 0,
  prelievoConfermato: false,
  numColliDaSpedire: 0,
  numColliPrelevati: 0,
  numUnitaPerCollo: 0,
  codMagazzSpedizione: '',
  codAreaMagSpedizione: '',
  qtaUmMagDaSpedire: 0,
  qtaUmMagPrelevata: 0,
  umMag: '',
  forzaSaldoRigaOrdine: false
};
const emptyOrdSpedEsolver: OrdSpedEsolver = {
  dbgruppo: '',
  idDocumento: 0,
  idRiga: 0,
  codClasseDoc: 0,
  periodoRifNumeraz: 0,
  codSerie: 0,
  numRegistraz: 0,
  dataRegistraz: new Date(),
  dataDoc: new Date(),
  numDocumento: '',
  esercizioContabile: 0,
  gruppoDoc: '',
  codCliFor: 0,
  codCausaleTrasporto: '',
  desCausaleTrasporto: '',
  codPorto: '',
  desPorto: '',
  aspettoBeni: '',
  desAspettoBeni: '',
  codTrasportoAmezzo: '',
  desTrasportoAmezzo: '',
  spedNumRifIndir: 0,
  spedRagSoc1: '',
  spedRagSoc2: '',
  spedIndir1: '',
  spedIndir2: '',
  spedCap: '',
  spedLocalita1: '',
  spedLocalita2: '',
  spedProv: '',
  umPeso: '',
  totPesoLordo: 0,
  totPesoNetto: 0,
  umVolume: '',
  totVolume: 0,
  totaleColli: 0,
  spedIdAnagGen: 0,
  statoSpedizione: 0,
  codMagPrelievo: '',
  codAreaMagPrelievo: '',
  codMagTerzista: '',
  codAreaMagTerzista: '',
  codMagSped: '',
  spedCodCliFor: 0,
  codArt: '',
  varianteArt: '',
  desArt: '',
  rigaSaldata: false,
  codMag: '',
  codAreaMag: '',
  riferimentoRiga: '',
  lottoMagTipoGestione: 0,
  dataConsegnaConferm: new Date(),
  unitaMisura: '',
  qtaDaSpedire: 0,
  um2: '',
  qta2DaSpedire: 0,
  qtaPrelevata: 0,
  prelievoConfermato: false,
  numColliDaSpedire: 0,
  numColliPrelevati: 0,
  numUnitaPerCollo: 0,
  codMagazzSpedizione: '',
  codAreaMagSpedizione: '',
  qtaUmMagDaSpedire: 0,
  qtaUmMagPrelevata: 0,
  umMag: '',
  forzaSaldoRigaOrdine: false
};

@Injectable({providedIn: 'root'})
export class OrdinispedizioniService {
  public handleRefresh = new Subject();
  public handleSave: Subject<number> = new Subject();

  public searchOrdSpedGroup: BehaviorSubject<OrdSpedGroup> = new BehaviorSubject<OrdSpedGroup>(emptyOrdSped);

  public lastOrdSpedLaunched: Subject<OrdSped> = new Subject<OrdSped>();
  public lastOrdSpedCreated: BehaviorSubject<OrdSped> = new BehaviorSubject<OrdSped>(null);
  public lastOrdSpedUpdated: BehaviorSubject<OrdSped> = new BehaviorSubject<OrdSped>(null);
  public lastOrdSpedDeleted: BehaviorSubject<OrdSped> = new BehaviorSubject<OrdSped>(null);
  public hubState: BehaviorSubject<number> = new BehaviorSubject<number>(HubState.Connecting);
  private hubConnection: HubConnection;

  constructor(
    private http: HttpClient,
    private authService: AuthenticationService,
    private organizzazioniService: OrganizzazioniService,
    private saveMessage: SaveMessage) {
    const storedOrdineGroup = JSON.parse(localStorage.getItem(cachePrefix + 'spedizioneGroup'));
    const ordineGroup = storedOrdineGroup
      ? {...emptyOrdSped, ...storedOrdineGroup, isLoading: false}
      : emptyOrdSped;
    this.searchOrdSpedGroup.next(ordineGroup);
  }

  public startConnection() {
    this.hubConnection = buildHubConnection(`${environment.localApiUrl}hubs/ordinispedizioni`, this.hubState);

    this.hubConnection.on('SendCreated', (spedizione: OrdSped) => {
      if (spedizione.organizzazioneId === this.organizzazioniService.organizzazioneId) {
        const rifOdS = this.getRifOdS(spedizione);
        const actorSuffix = this.getActorSuffix(spedizione.executedBy);
        const message = rifOdS
          ? `Nuova spedizione creata sull'ordine ${rifOdS}${actorSuffix}.`
          : `Nuova spedizione creata${actorSuffix}.`;
        this.saveMessage.messageInfo(message);
        this.lastOrdSpedCreated.next(spedizione);
      }
    });

    this.hubConnection.on('SendUpdated', (spedizione: OrdSped) => {
      if (spedizione.organizzazioneId === this.organizzazioniService.organizzazioneId) {
        const rifOdS = this.getRifOdS(spedizione);
        const message = rifOdS
          ? `Ordine aggiornato: ${rifOdS}.`
          : 'Ordine aggiornato.';
        this.saveMessage.messageInfo(message);
        this.lastOrdSpedUpdated.next(spedizione);
      }
    });

    this.hubConnection.on('SendDeleted', (spedizione: OrdSped) => {
      if (spedizione.organizzazioneId === this.organizzazioniService.organizzazioneId) {
        const rifOdS = this.getRifOdS(spedizione);
        const message = rifOdS
          ? `Ordine eliminato: ${rifOdS}.`
          : 'Ordine eliminato.';
        this.saveMessage.messageInfo(message);
        this.lastOrdSpedDeleted.next(spedizione);
      }
    });

    return startHubConnection(this.hubConnection, this.hubState);
  }

  public stopConnection() {
    void stopHubConnection(this.hubConnection);
  }

  getEmptyOrdSped = () => emptyOrdSped;

  getEmptyOrdSpedEsolver = () => emptyOrdSpedEsolver;

  setOrdSpedGroup(spedizioneGroup: OrdSpedGroup, onlyStorageUpdate?: boolean) {
    localStorage.setItem(cachePrefix + 'spedizioneGroup', JSON.stringify(spedizioneGroup));
    if (!onlyStorageUpdate) {
      this.searchOrdSpedGroup.next(spedizioneGroup);
    }
  }

  resetOrdSpedGroup(onlyStorageUpdate?: boolean, isLoading?: boolean) {
    const copySpedizione = {...emptyOrdSped, isLoading};
    localStorage.setItem(cachePrefix + 'spedizioneGroup', JSON.stringify({...copySpedizione, isLoading: false}));
    if (!onlyStorageUpdate) {
      this.searchOrdSpedGroup.next(copySpedizione);
    }
  }

  getSpedizioniInviatiFiltered(
    orgId: number,
    terminato: boolean,
    search: string,
    page: number,
    count: number,
    sortField: string,
    sortAsc: boolean,
    stato: number,
    numRegistraz: number,
    codArt: string,
    cliente: string) {
    return firstValueFrom(
      this.http.post<SearchResult<OrdSped>>(`${environment.localApiUrl}api/Spedizioni/OrdiniSpedizione`,
        {orgId, terminato, search, page, count, sortField, sortAsc, stato, numRegistraz, codArt, cliente})
    );
  }

  getSpedizioniEsolver(
    orgId: number,
    group: string,
    connectionName: string,
    search: string,
    page: number,
    count: number,
    sortField: string,
    sortAsc: boolean,
    stato: number,
    saldato: boolean,
    filters: FilterItem[],
    noKeyFilter: boolean,
    numRegistraz: number = -1,
    codArt: string = '',
    cliente: string = '',
    // Feature 156: articolo e variante esatti (non «contiene») ed esclusione delle spedizioni terminate
    codArtEsatto: boolean = false,
    varianteArt: string = '',
    escludiTerminate: boolean = false) {
    return firstValueFrom(this.http.post<SearchResult<OrdSpedEsolver>>(`${environment.localApiUrl}api/Spedizioni/OrdiniSpedizioneEsolver`,
      {
        orgId, group, connectionName, search, page, count, sortField, sortAsc, saldato, stato, filters, noKeyFilter,
        numRegistraz, codArt, cliente, codArtEsatto, varianteArt, escludiTerminate
      }));
  }

  // Cerca l'OrdSped locale per NumRegistraz + CodArt (feature 041, Parte D).
  async getOrdineSpedizioneLocaleByNumRegistraz(
    orgId: number, numRegistraz: number, codArt: string): Promise<OrdSped | null> {
    const result = await this.getSpedizioniInviatiFiltered(
      orgId, false, '', 0, 1, '', true, -1, numRegistraz, codArt, '');
    return result.result?.[0] ?? null;
  }

  // Cerca l'OrdSped su ESOLVER per NumRegistraz + CodArt (feature 041, Parte D).
  async getOrdineSpedizioneEsolverByNumRegistraz(
    orgId: number, group: string, connectionName: string,
    numRegistraz: number, codArt: string): Promise<OrdSpedEsolver | null> {
    const result = await this.getSpedizioniEsolver(
      orgId, group, connectionName, '', 0, 1, '', true, -1, false, [], true, numRegistraz, codArt, '');
    return result.result?.[0] ?? null;
  }

  async getOrdineSpedizione(orgId: number, idDocumento: number, idRiga: number) {
    return firstValueFrom(this.http.get<OrdSped>(`${environment.localApiUrl}api/Spedizioni/OrdineSpedizione?orgId=${orgId}&idDocumento=${idDocumento}&idRiga=${idRiga}`));
  }

  async createOrdineSpedizione(spedizione: OrdSped) {
    spedizione.executedBy ??= this.getNotificationActor();
    return firstValueFrom(this.http.post<OrdSped>(`${environment.localApiUrl}api/Spedizioni/CreateOrdineSpedizione`, spedizione));
  }

  async updateOrdineSpedizione(spedizione: OrdSped) {
    spedizione.executedBy ??= this.getNotificationActor();
    return firstValueFrom(this.http.post<OrdSped>(`${environment.localApiUrl}api/Spedizioni/UpdateOrdineSpedizione`, spedizione));
  }

  async deleteOrdineSpedizione(orgId: number, idDocumento: number, idRiga: number) {
    return firstValueFrom(this.http.get<OrdSped>(`${environment.localApiUrl}api/Spedizioni/DeleteOrdineSpedizione?orgId=${orgId}&idDocumento=${idDocumento}&idRiga=${idRiga}`));
  }

  getBoxOfSpedizione(orgId: number, idDocumento: number, idRiga: number) {
    return firstValueFrom(this.http
      .get<SearchResult<OrdSpedBox>>(`${environment.localApiUrl}api/Spedizioni/BoxOfOrdineSpedizione/${orgId}/${idDocumento}/${idRiga}`));
  }

  async createSpedizioneBox(box: OrdSpedBox) {
    return firstValueFrom(this.http.post<OrdSpedBox>(`${environment.localApiUrl}api/Spedizioni/CreateBox`, box));
  }

  async updateSpedizioneBox(box: OrdSpedBox) {
    return firstValueFrom(this.http.post<OrdSpedBox>(`${environment.localApiUrl}api/Spedizioni/UpdateBox`, box));
  }

  async deleteSpedizioneBox(box: OrdSpedBox) {
    return firstValueFrom(this.http.post<any>(`${environment.localApiUrl}api/Spedizioni/DeleteBox`, box));
  }

  // Feature 148: sposta un collo su un'altra riga di spedizione, con invio facoltativo a eSOLVER.
  async spostaCollo(orgId: number, request: SpostaColloRequest) {
    request.operatore ??= this.getNotificationActor();
    return firstValueFrom(this.http.post<SpostaColloEsito>(`${environment.localApiUrl}api/Spedizioni/SpostaCollo/${orgId}`, request));
  }

  // Feature 148: sposta un bancale con tutti i suoi colli su un'altra riga di spedizione.
  async spostaBancale(orgId: number, request: SpostaBancaleRequest) {
    request.operatore ??= this.getNotificationActor();
    return firstValueFrom(this.http.post<SpostaColloEsito>(`${environment.localApiUrl}api/Spedizioni/SpostaBancale/${orgId}`, request));
  }

  async getRisorseOfSpedizione(orgId: number, idDocumento: number, idRiga: number) {
    return firstValueFrom(this.http
      .get<SearchResult<OrdSpedRisorsa>>(`${environment.localApiUrl}api/Spedizioni/RisorseOfOrdineSpedizione/${orgId}/${idDocumento}/${idRiga}`));
  }

  async setSpedizioneRisorsa(risorsa: OrdSpedRisorsa) {
    return firstValueFrom(this.http.post<OrdSpedRisorsa>(`${environment.localApiUrl}api/Spedizioni/SetRisorsaOfOrdineSpedizione`, risorsa));
  }

  async unsetSpedizioneRisorsa(risorsa: OrdSpedRisorsa) {
    return firstValueFrom(this.http.post<OrdSpedRisorsa>(`${environment.localApiUrl}api/Spedizioni/UnsetRisorsaOfOrdineSpedizione`, risorsa));
  }

  unsetSpedizioneRisorsaBeacon(risorsa: OrdSpedRisorsa): void {
    try {
      const url = `${environment.localApiUrl}api/Spedizioni/UnsetRisorsaOfOrdineSpedizione`;
      const currentUser = this.authService.currentUserValue;
      const headers: Record<string, string> = {
        'Content-Type': 'application/json'
      };
      if (currentUser?.jwtToken) {
        headers['Authorization'] = `Bearer ${currentUser.jwtToken}`;
      }
      const body = JSON.stringify(risorsa);
      console.info('[OrdinispedizioniService] unsetSpedizioneRisorsaBeacon invio disattivazione risorsa', {
        url,
        risorsa
      });
      // fetch con keepalive e NON navigator.sendBeacon: il beacon non può impostare header, quindi
      // non porterebbe il Bearer e l'endpoint risponderebbe 401.
      fetch(url, {
        method: 'POST',
        headers,
        body,
        keepalive: true
      }).catch(err => console.warn('[OrdinispedizioniService] unsetSpedizioneRisorsaBeacon fetch failed', err));
    } catch (err) {
      console.error('[OrdinispedizioniService] unsetSpedizioneRisorsaBeacon failed', err);
    }
  }

  async updatePesoMedioUnitFromBilancia(request: UpdatePesoMedioUnitFromBilanciaRequest): Promise<void> {
    return firstValueFrom(this.http.post<void>(
      `${environment.localApiUrl}api/Spedizioni/UpdatePesoMedioUnitFromBilancia`,
      request
    ));
  }

  async getActiveOrdineSpedizioneByRisorsa(orgId: number, codiceRisorsa: string) {
    return firstValueFrom(this.http.post<OrdSpedRisorsa>(
      `${environment.localApiUrl}api/Spedizioni/GetActiveOrdineSpedizioneByRisorsa/${orgId}`,
      {codiceRisorsa}
    ));
  }

  async getReportBancale(orgId: number, idDocumento: number, codUnita: string) {
    return firstValueFrom(this.http.post<ReportResult>(`${environment.localApiUrl}api/Spedizioni/GetBancaleReport/${orgId}`,
      {idDocumento, codUnita}));
  }

  async getReportCollo(orgId: number, idDocumento: number, codUnita: string, codCollo: string) {
    return firstValueFrom(this.http.post<ReportResult>(`${environment.localApiUrl}api/Spedizioni/GetColloReport/${orgId}`,
      {idDocumento, codUnita, codCollo}));
  }

  // Scarica il PDF dell'etichetta bancale come file (formato pagina corretto in stampa).
  async getReportBancaleFile(orgId: number, idDocumento: number, codUnita: string): Promise<Blob> {
    return firstValueFrom(this.http.post(`${environment.localApiUrl}api/Spedizioni/GetBancaleReportFile/${orgId}`,
      {idDocumento, codUnita}, {responseType: 'blob'}));
  }

  // Scarica il PDF dell'etichetta collo come file (formato pagina corretto in stampa).
  async getReportColloFile(orgId: number, idDocumento: number, codUnita: string, codCollo: string): Promise<Blob> {
    return firstValueFrom(this.http.post(`${environment.localApiUrl}api/Spedizioni/GetColloReportFile/${orgId}`,
      {idDocumento, codUnita, codCollo}, {responseType: 'blob'}));
  }

  private getNotificationActor(): string | undefined {
    return this.organizzazioniService.codiceOperatore ?? this.authService.currentUserValue?.userName;
  }

  private getActorSuffix(executedBy?: string): string {
    const actor = executedBy?.trim();
    return actor ? ` da ${actor}` : '';
  }

  private getRifOdS(spedizione: OrdSped): string | null {
    if (!spedizione?.idDocumento || spedizione.idDocumento <= 0) {
      return null;
    }
    if (spedizione.idRiga > 0) {
      return `${spedizione.idDocumento}.${spedizione.idRiga}`;
    }
    return `${spedizione.idDocumento}`;
  }
}
